

/** @name 编辑区表单项协议【使用到FormItemTemplate.vue组件的根组件需要实现该协议】
 *  @author 王汝鹏
 *  @version 2019-11-28
 */
export const mixFormItemTemplateProtocol = {
  provide() {
    return {
      form_item_template_store: this.form_item_template_store,
      form_item_template_event_config_manager: this.form_item_template_event_config_manager,
      form_item_template_form_node_manager: this.form_item_template_form_node_manager,
      form_item_template_form_list_manager: this.form_item_template_form_list_manager,
    }
  },
  computed: {
    /** 协议数据声明 [空实现，需要在使用的地方重写方法] ::: 
     *  @return {Object} activeNode 激活表单项
     *  @return {Object} formMap 表单项字典
     */
    form_item_template_store: {
      get() { 
        return {
          activeNode: {},
          formMap: {},
        }; 
      }
    },
    /** 协议方法声明 [空实现，需要在使用的地方重写方法] ::: 
     *  @function form_item_template_event_config_manager 事件配置管理者
     *  @function form_item_template_form_node_manager 表单项节点管理者
     *  @function form_item_template_form_list_manager 表单列表管理者
     */
    form_item_template_event_config_manager: { get() { return new Function('eventId', 'return {};'); } },
    form_item_template_form_node_manager: { get() { return new Function('formNode', 'return {};'); } },
    form_item_template_form_list_manager: { get() { return new Function('return {};'); } }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form_item/mix_form_item_template_protocol.js